import React, { useState } from "react";
import logo from "../../assets/images/logo.png";
import "./CandRegister.css";
import { useDispatch } from "react-redux";
import { useCandidateRegisterMutation } from "../../slice/authApiSlice";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import MobileCandidateReg from "./mcandidate/MobileCandidateReg";

const CandRegister = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [status, setStatus] = useState("");
  const [contactNumber, setContectNumber] = useState("");
  const [location, setLocation] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  const [register, { isLoading }] = useCandidateRegisterMutation();
  const [selectedButton, setSelectedButton] = useState(null);

  const handleButtonClick = (e) => {
    e.preventDefault();
    setSelectedButton(e.target.value);
    setStatus(e.target.value);
  };

  const handleModalClick = () => {
    setModalOpen(false);
  };

  const registerHandler = async () => {
    if (!status) return toast.error("Status is required.");
    if (!firstName) return toast.error("First name is required.");
    if (!lastName) return toast.error("Last name is required.");
    if (!contactNumber || !/^\d{10}$/.test(contactNumber)) {
      return toast.error("Valid 10-digit contact number is required.");
    }
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      return toast.error("Valid email is required.");
    }
    if (!password || password.length < 6) {
      return toast.error("Password must be at least 6 characters long.");
    }
    if (password !== confirmPassword) {
      return toast.error("Passwords do not match.");
    }
    if (!location) return toast.error("Location is required.");

    const payload = {
      email,
      password,
      firstName,
      lastName,
      status,
      contactNumber,
      location,
    };

    try {
      const res = await register(payload).unwrap();
      toast.success("Account created successfully 🎉");
      setModalOpen(true);
      onSubmit(); // closes modal
    } catch (error) {
      toast.error(error?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="cand_register_section">
      {/* Optional success modal */}
      {/* {modalOpen && (
        <Popup onClose={handleModalClick} onSubmit={handleModalClick} />
      )} */}

      <div className="cand_register_container section_padding">
        <div className="cand_register_left_side">
          <div className="cand_reg_logo_section">
            <div>
              <img src={logo} alt="logo" />
            </div>
            <div className="cand_heading_section">
              <h2>CAREER</h2>
              <h2>EDUCATION</h2>
              <h2>SOCIAL</h2>
            </div>
          </div>
          <div className="cand_pnt_container">
            <p>Privacy Policy</p>
            <p>Terms & Conditions</p>
          </div>
        </div>

        <div className="cand_register_right_side">
          <div className="close_button_container">
            <button>
              <IoMdClose className="cross_icon" onClick={() => onClose()} />
            </button>
          </div>

          <div className="cand_register_right_side_heading">
            <h1>Create your Riso account</h1>
            <p>Join our socio-community!</p>
          </div>

          <div className="cand_register_right_side_form_container">
            <form>
              <div className="cand_reg_form_input_one">
                <label>Work Status</label>
                <div>
                  <button
                    className={selectedButton === "I am a student" ? "selected" : "notselect"}
                    type="text"
                    value="I am a student"
                    onClick={handleButtonClick}
                  >
                    I am a student
                  </button>
                  <button
                    className={selectedButton === "I am a fresher" ? "selected" : "notselect"}
                    type="text"
                    value="I am a fresher"
                    onClick={handleButtonClick}
                  >
                    I am a fresher
                  </button>
                  <button
                    className={selectedButton === "I am experienced" ? "selected" : "notselect"}
                    type="text"
                    value="I am experienced"
                    onClick={handleButtonClick}
                  >
                    I am experienced
                  </button>
                </div>
              </div>

              <div className="cand_reg_form_input_two form_field">
                <div>
                  <label>First Name</label>
                  <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div>
                  <label>Last Name</label>
                  <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
              </div>

              <div className="cand_reg_form_input_three form_field">
                <div>
                  <label>Phone Number</label>
                  <input type="tel" value={contactNumber} onChange={(e) => setContectNumber(e.target.value)} />
                </div>
                <div>
                  <label>Email Id</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
              </div>

              <div className="cand_reg_form_input_five form_field">
                <div>
                  <label>Password</label>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div>
                  <label>Confirm Password</label>
                  <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                </div>
              </div>

              <div className="cand_reg_form_input_five form_field">
                <div>
                  <label>Location</label>
                  <input type="text" value={location} onChange={(e) => setLocation(e.target.value)} />
                </div>
              </div>
            </form>

            <div>
              <button
                className="register_submit_button"
                onClick={registerHandler}
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Create Account"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mc_reg_section">
        <MobileCandidateReg onClose={() => onClose()} />
      </div>
    </div>
  );
};

export default CandRegister;
